import { useGlobal } from "../context/ContenedorGlobal";
import { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";
import "../styles/Formularios.css";
import "../styles/ReportesPorCategoria.css";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import InputInventario from "./InputInventario";
import InputSelectEstados from "./InputSelectEstados";
import InputBienesAutocomplete from "./InputBienesAutocomplete";
import InputUsuarioAutocomplete from "./InputUsuarioAutocomplete";
import InputSelectIp from "./InputSelectIp";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function ReporteBienes({ setVista }) {

    const { logout } = useGlobal();
    const apiFetch = useApiFetch();
    const [vistaLocal, setVistaLocal] = useState("opcionesBienes")

    const [filtroPrincipal, setFiltroPrincipal] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [resultados, setResultados] = useState([]);

    const [serieBien, setSerieBien] = useState(null);
    const [idIp, setIdIp] = useState(null);
    const [idTipo, setIdTipo] = useState(null);
    const [marca, setMarca] = useState(null);
    const [modelo, setModelo] = useState(null);
    const [versionSoft, setVersionSoft] = useState(null);
    const [inventario, setInventario] = useState(null);
    const [idEstado, setIdEstado] = useState(null);
    const [idPropietario, setIdPropietario] = useState(null);
    const [idResg, setIdResg] = useState(null);
    const [idUso, setIdUso] = useState(null);
    const [fechaInicial, setFechaInicial] = useState(null);
    const [fechaFinal, setFechaFinal] = useState(null);
    const [fechaAsig, setFechaAsig] = useState(null);
    const [todos, setTodos] = useState(null); //--

    const [resetEntrada, setResetEntrada] = useState(false);
    const [resetEntradaUsuario, setResetEntradaUsuario] = useState(false);

    // Estado para checkboxes de filtros //////////////////////////ok
    const filtrosIniciales = {
        opcSerie: false,
        opcIp: false,
        opcTipo: false,
        opcMarca: false,
        opcModelo: false,
        opcVersion: false,
        opcInventario: false,
        opcEstado: false,
        opcPropietario: false,
        opcResg: false,
        opcUso: false,
        opcRangoFechas: false,
        opcTodos: false
    };

    const [filtros, setFiltros] = useState(filtrosIniciales); ///////////////////ok

    // Diccionario de etiquetas para mostrar al usuario /////////////////////ok
    const etiquetas = {
        opcSerie: "Serie",
        opcIp: "Ip",
        opcTipo: "Tipo de bien",
        opcMarca: "Marca",
        opcModelo: "Modelo",
        opcVersion: "Versión",
        opcInventario: "Inventario",
        opcEstado: "Estado del bien",
        opcPropietario: "Propietario",
        opcResg: "Resguardante",
        opcUso: "Operador",
        opcRangoFechas: "Rango de Fechas",
        opcTodos: "Todos los registros"
    };

    // Reglas de habilitación/deshabilitación por cada opcion elegida, para que las consultas tengan sentido ///////////////////ok
    const reglas = {
        opcSerie: {
            deshabilita: [
                "opcIp", "opcTipo", "opcMarca", "opcModelo", "opcVersion", "opcInventario", "opcEstado", "opcPropietario", "opcResg", "opcUso", "opcRangoFechas", "opcTodos"]
        },
        opcIp: {
            deshabilita: [
                "opcSerie", "opcTipo", "opcMarca", "opcModelo", "opcVersion", "opcInventario", "opcEstado", "opcPropietario", "opcResg", "opcUso", "opcRangoFechas", "opcTodos"]
        },
        opcTipo: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcMarca: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcModelo: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcVersion: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcInventario: {
            deshabilita: [
                "opcSerie", "opcIp", "opcTipo", "opcMarca", "opcModelo", "opcVersion", "opcEstado", "opcPropietario", "opcResg", "opcUso", "opcRangoFechas", "opcTodos"]
        },
        opcEstado: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcPropietario: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcResg: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcUso", "opcTodos"]
        },
        opcUso: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcResg", "opcTodos"]
        },
        opcRangoFechas: {
            deshabilita: [
                "opcSerie", "opcIp", "opcInventario", "opcTodos"]
        },
        opcTodos: {
            deshabilita: [
                "opcSerie", "opcIp", "opcTipo", "opcMarca", "opcModelo", "opcVersion", "opcInventario", "opcEstado", "opcPropietario", "opcResg", "opcUso", "opcRangoFechas"]
        }
    };

    // Función para visualizar o no las opciones de filtrado segun el campo principal elegido ////////////ok
    const handleChange = (campo) => {
        const nuevaConfig = { ...filtros };

        if (filtros[campo]) {
            // Si se desmarca un campo
            nuevaConfig[campo] = false;

            // Si era el filtro principal, se quita y se reestablece todo
            if (filtroPrincipal === campo) {
                setFiltroPrincipal(null);
                // Reinicia todos los filtros a su estado inicial
                Object.keys(nuevaConfig).forEach(opc => {
                    nuevaConfig[opc] = false;
                });
            }

        } else {
            // Si se activa el campo
            nuevaConfig[campo] = true;

            // Si aún no hay filtro principal, este se convierte en el principal
            if (!filtroPrincipal) {
                setFiltroPrincipal(campo);

                // Se aplican reglas de deshabilitación SOLO del principal
                if (reglas[campo]?.deshabilita) {
                    reglas[campo].deshabilita.forEach(opc => {
                        nuevaConfig[opc] = false;
                    });
                }
            }
            // Si ya existe un filtro principal, no se cambian las reglas
        }

        setFiltros(nuevaConfig);
    };

    // Funcion para limpiar los mensajes   ////////////////////////////////////////////ok
    useEffect(() => {
        if (success || error) {
            const timer = setTimeout(() => {
                setSuccess("");
                setError("");
            }, 3000);

            return () => clearTimeout(timer); // Limpia el timer si cambia el estado
        }
    }, [success, error]);

    // Limpiar los inpus para facilitar el reingreso de datos   /////////////////////////////////////ok
    const handleLimpiar = () => {
        setSerieBien("");
        setIdIp("");
        setIdTipo("");
        setMarca("");
        setModelo("");
        setVersionSoft("");
        setInventario("");
        setIdEstado("");
        setIdPropietario("");
        setIdResg("");
        setIdUso("");
        setFechaInicial("");
        setFechaFinal("");

        setResultados([]);
        setSuccess("");
        setError("");

        setResetEntrada(true); // Para limpiar el autocomplete de bienes
        setTimeout(() => setResetEntrada(false), 0);    // Volver a false para que pueda usarse otra vez

        setResetEntradaUsuario(true);   // Para limpiar el autocomplete de usuarios
        setTimeout(() => setResetEntradaUsuario(false), 0); // Volver a false para que pueda usarse otra vez
    };

    // Función para realizar validaciones de filtros seleccionados y los valores de sus variables  /////////////////////////////ok
    function validarCampos(filtros, {
        serieBien,
        idIp,
        idTipo,
        marca,
        modelo,
        versionSoft,
        inventario,
        idEstado,
        idPropietario,
        idResg,
        idUso,
        fechaInicial,
        fechaFinal
    }) {
        // Todos
        if (filtros.opcTodos) {
            return { valido: true, mensaje: "" };
        }

        // Serie
        if (filtros.opcSerie && !serieBien) {
            return { valido: false, mensaje: "Debes ingresar el número de serie." };
        }

        // Ip
        if (filtros.opcIp && !idIp) {
            return { valido: false, mensaje: "Debes ingresar una ip." };
        }

        // Tipo
        if (filtros.opcTipo && !idTipo) {
            return { valido: false, mensaje: "Debes seleccionar un tipo de bien." };
        }

        // Marca
        if (filtros.opcMarca && !marca) {
            return { valido: false, mensaje: "Debes ingresar una marca." };
        }

        // Modelo
        if (filtros.opcModelo && !modelo) {
            return { valido: false, mensaje: "Debes ingresar un modelo." };
        }

        // Versión
        if (filtros.opcVersion && !versionSoft) {
            return { valido: false, mensaje: "Debes ingresar una versión de software." };
        }

        // Inventario
        if (filtros.opcInventario && !inventario) {
            return { valido: false, mensaje: "Debes ingresar un número de inventario." };
        }

        // Estado del bien
        if (filtros.opcEstado && !idEstado) {
            return { valido: false, mensaje: "Debes seleccionar un estado del bien." };
        }

        // Propietario
        if (filtros.opcPropietario && !idPropietario) {
            return { valido: false, mensaje: "Debes seleccionar un propietario." };
        }

        // Usuario resguardante
        if (filtros.opcResg && !idResg) {
            return { valido: false, mensaje: "Debes seleccionar un usuario resguardante." };
        }

        // Usuario oparador
        if (filtros.opcUso && !idUso) {
            return { valido: false, mensaje: "Debes seleccionar un usuario operador." };
        }

        // Rango de fechas
        if (filtros.opcRangoFechas) {
            if (!fechaInicial || !fechaFinal) {
                return { valido: false, mensaje: "Debes ingresar ambas fechas." };
            }
            if (new Date(fechaFinal) <= new Date(fechaInicial)) {
                return { valido: false, mensaje: "La fecha final debe ser mayor a la inicial." };
            }
        }

        // Si pasa todas las validaciones
        return { valido: true, mensaje: "" };
    }

    // Diccionario de cabeceras para la lista de resultado en PDF //////////////////////////ok
    const diccionarioCabeceras = {
        serieBien: "Serie",
        idIp: "Ip",
        idTipo: "Tipo",
        marca: "Marca",
        modelo: "Modelo",
        versionSoft: "Versión",
        inventario: "Inventario",
        idEstado: "Estado",
        idPropietario: "Propietario",
        idResg: "Resguardante",
        idUso: "Operador",
        fechaAsig: "Fecha Asignación"
    };

    // Función para mostrar solo ciertas columnas y no saturar la pantalla con exceso de información //////////////ok
    const columnasVisibles = [
        "serieBien",
        "idTipo",
        "idEstado",
        "idResg",
        "idUso"
    ];

    // Función para conectar y enviar los datos a la api
    const handleGenerarReporte = async () => {
        const valores = {
            serieBien,
            idIp,
            idTipo,
            marca,
            modelo,
            versionSoft,
            inventario,
            idEstado,
            idPropietario,
            idResg,
            idUso,
            fechaInicial,
            fechaFinal,

            filtroPrincipal
        };

        const resultado = validarCampos(filtros, valores);

        if (!resultado.valido) {
            setError(resultado.mensaje);
            setSuccess("");
            return;
        }

        try {
            const data = await apiFetch("reporte_bienes.php", {
                method: "POST",
                body: JSON.stringify(valores),
                headers: { "Content-Type": "application/json" }
            }, logout);

            if (data.status === "ok" && data.data.length > 0) {
                setResultados(data.data || []); // Se guardan los resultados
                setSuccess("Reporte generado correctamente.");
                setVistaLocal("resultados");
                setError("");
            } else if (data.status === "no_results") {
                setError("No se encontraron registros que cumplan con los filtros.");
                setSuccess("");
            } else {
                setError("Error al generar reporte: " + (data.message || "Error desconocido."));
                setSuccess("");
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
            setSuccess("");
        }
    };

    // Funcion para exportar en CSV (todas las columnas de la consulta)
    const exportCSV = () => {
        if (!resultados.length) return;

        const columnas = Object.keys(resultados[0]); // Todas las columnas no solo las visibles en PDF
        const filas = resultados.map(fila =>
            columnas.map(col => {
                let valor = fila[col] !== null ? String(fila[col]) : "";
                // Escapar comillas dobles
                valor = valor.replace(/"/g, '""');
                // Encapsular en comillas si contiene coma, salto de línea o comillas para mantener dato y encabezado correctos
                if (/[",\n]/.test(valor)) {
                    valor = `"${valor}"`;
                }
                return valor;
            })
        );

        const csvRows = [];
        csvRows.push(columnas.join(",")); // Encabezados
        filas.forEach(row => csvRows.push(row.join(",")));

        const csvString = csvRows.join("\n");
        const BOM = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reporte_bienes.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Función para exportar en PDF (solo lo que se muestra en la tabla)
    const exportPDF = () => {
        if (!resultados.length) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de bienes", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla con columnas visibles
        autoTable(doc, {
            startY: 50,
            head: [columnasVisibles.map(col => diccionarioCabeceras[col] || col)],
            body: resultados.map(fila =>
                columnasVisibles.map(col => fila[col])
            )
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("reporte_bienes.pdf");
    };

    // Función para regresar de la vista formulario a la vista de seleccion de opciones de filtrado   ////////////////////////////ok
    const handleRegresar = () => {
        handleLimpiar();
        setSuccess("");
        setError("");
        setVistaLocal("opcionesBienes");
    };

    // Función para regresar al formulario
    const handleRegresarFormulario = () => {
        handleLimpiar();
        setSuccess("");
        setError("");
        setResultados([]);

        if (filtroPrincipal === "opcTodos") {
            // Caso especial: no hay formulario, regresar a opciones
            setVistaLocal("opcionesBienes");
        } else {
            // Flujo normal: regresar al formulario
            setVistaLocal("formulario");
        }
    };

    return (
        <div className="sesion-form">
            {vistaLocal === "opcionesBienes" && (
                <div>
                    {error && <div className="error">{error}</div>}

                    <div className="filtros-container">
                        {Object.keys(filtros).map((campo) => {
                            const deshabilitado = filtroPrincipal
                                ? reglas[filtroPrincipal]?.deshabilita?.includes(campo)
                                : false;

                            return (
                                <label
                                    key={campo}
                                    className={deshabilitado ? "checkbox-disabled" : "checkbox-enabled"}
                                >
                                    <input
                                        type="checkbox"
                                        checked={filtros[campo]}
                                        onChange={() => handleChange(campo)}
                                        disabled={deshabilitado}
                                    />
                                    {etiquetas[campo]}
                                </label>
                            );
                        })}
                    </div>

                    <div className="form-buttons">
                        <button
                            onClick={() => {
                                const algunFiltroActivo = Object.values(filtros).some(v => v === true);

                                if (!algunFiltroActivo) {
                                    setError("Debes seleccionar al menos un filtro antes de continuar.");
                                    return;
                                }

                                setError(""); // Limpia el error si todo está bien

                                if (filtroPrincipal === "opcTodos") {
                                    // Caso especial: no pasar por formulario
                                    handleGenerarReporte();
                                    setVistaLocal("resultados");
                                } else {
                                    // Flujo normal: ir al formulario
                                    setVistaLocal("formulario");
                                }
                            }}
                        >
                            Continuar
                        </button>

                        <button onClick={() => {
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                        }}>
                            Limpiar
                        </button>

                        <button onClick={() => {
                            setFiltros(filtrosIniciales);
                            setFiltroPrincipal(null);
                            setVista("hardware")
                        }}>
                            Volver
                        </button>
                    </div>
                </div>
            )}

            {vistaLocal === "formulario" && (
                <div>
                    {error && <div className="error">{error}</div>}

                    <h3>Ingrese los datos para generar el reporte</h3>

                    {filtros.opcSerie && (
                        <div>
                            <InputBienesAutocomplete
                                idSeleccionado={serieBien}
                                setIdSeleccionado={setSerieBien}
                                label="Ingrese la serie del bien"
                                placeholder="MXL1234ABC"
                                title="Máximo 30 caracteres"
                                readOnly={false}
                                maxLength={30}
                                resetEntrada={resetEntrada}
                            />
                        </div>
                    )}

                    {filtros.opcIp && (
                        <div>
                            <InputSelectIp
                                idIp={idIp}
                                setIdIp={setIdIp}
                                estadoFiltro={null}
                                label="Seleccione una ip"
                            />
                        </div>
                    )}

                    {filtros.opcTipo && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idTipo}
                                setIdSeleccionado={setIdTipo}
                                label="Tipo de bien"
                                apiUrl={`consultar_tipo_bienes.php`}
                                valueField="id_tipo"
                                displayField="tipo_bien"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione un tipo"
                            />
                        </div>
                    )}

                    {filtros.opcMarca && (
                        <div>
                            <InputGenerico
                                value={marca}
                                setValue={setMarca}
                                label="Marca"
                                maxLength={50}
                                allowedChars="A-Z0-9/_\- "
                                transform="uppercase"
                                placeholder="HP"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcModelo && (
                        <div>
                            <InputGenerico
                                value={modelo}
                                setValue={setModelo}
                                label="Modelo"
                                maxLength={50}
                                allowedChars="A-Z0-9/_\- "
                                transform="uppercase"
                                placeholder="PRODESK 700"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcVersion && (
                        <div>
                            <InputGenerico
                                value={versionSoft}
                                setValue={setVersionSoft}
                                label="Versión software"
                                maxLength={50}
                                allowedChars="A-Z0-9/_\- "
                                transform="uppercase"
                                placeholder="WINDOWS 11 N/A"
                                title="Máximo 50 caracteres"
                            />
                        </div>
                    )}

                    {filtros.opcInventario && (
                        <div>
                            < InputInventario
                                inventario={inventario}
                                setInventario={setInventario}
                            />
                        </div>
                    )}

                    {filtros.opcEstado && (
                        <div>
                            <InputSelectEstados
                                idEstado={idEstado}
                                setIdEstado={setIdEstado}
                                estadoActualText=""
                                idEntidad={1}
                                label="Estado del bien"
                                mostrar="todos" // Se pasa la prop "mostrar" con valor "todos" para que muestre todos los estados de la entidad y no realice los filtros de eliminados
                            />
                        </div>
                    )}

                    {filtros.opcPropietario && (
                        <div>
                            <InputSelectGenerico
                                idSeleccionado={idPropietario}
                                setIdSeleccionado={setIdPropietario}
                                label="Propietario"
                                apiUrl={`consultar_propietarios.php`}
                                valueField="id_propietario"
                                displayField="propietario"
                                readOnly={false}
                                showDefaultOption={true}
                                defaultOptionText="Seleccione el propietario"
                            />
                        </div>
                    )}

                    {filtros.opcResg && (
                        <div>
                            < InputUsuarioAutocomplete
                                idSeleccionado={idResg}
                                setIdSeleccionado={setIdResg}
                                label="Resguardante"
                                placeholder="Ingrese apellido paterno"
                                title="Seleccione al usuario resguardante"
                                readOnly={false}
                                maxLength={50}
                                resetEntrada={resetEntradaUsuario}
                            />
                        </div>
                    )}

                    {filtros.opcUso && (
                        <div>
                            < InputUsuarioAutocomplete
                                idSeleccionado={idUso}
                                setIdSeleccionado={setIdUso}
                                label="Operador"
                                placeholder="Ingrese apellido paterno"
                                title="Seleccione al usuario operador"
                                readOnly={false}
                                maxLength={50}
                                resetEntrada={resetEntradaUsuario}
                            />
                        </div>
                    )}

                    {filtros.opcRangoFechas && (
                        <div>
                            <label>Fecha inicial:</label>
                            <input
                                type="date"
                                value={fechaInicial}
                                onChange={(e) => setFechaInicial(e.target.value)}
                            />

                            <label>Fecha final:</label>
                            <input
                                type="date"
                                value={fechaFinal}
                                onChange={(e) => setFechaFinal(e.target.value)}
                            />
                        </div>
                    )}

                    <div className="form-buttons">
                        <button onClick={handleGenerarReporte}>
                            Generar<br />reporte
                        </button>
                        <button onClick={handleLimpiar}>
                            Limpiar<br />datos
                        </button>
                        <button onClick={handleRegresar}>
                            Regresar
                        </button>

                    </div>

                </div>
            )}

            {vistaLocal === "resultados" && (
                <div>
                    <h3>Resultados de bienes</h3>

                    {resultados.length > 0 && (
                        <>
                            <table className="tabla-estandar">
                                <thead>
                                    <tr>
                                        {columnasVisibles.map((col) => (
                                            <th key={col}>{diccionarioCabeceras[col] || col}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {resultados.map((fila, idx) => (
                                        <tr key={idx}>
                                            {columnasVisibles.map((col) => (
                                                <td key={col} data-label={diccionarioCabeceras[col] || col}>
                                                    {fila[col]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="form-buttons">
                                <button onClick={handleRegresarFormulario}>Regresar</button>
                                <button onClick={exportCSV}>Exportar<br></br>en CSV</button>
                                <button onClick={exportPDF}>Exportar<br></br>en PDF</button>
                            </div>
                        </>
                    )}

                </div>
            )}

        </div>
    );
}

export default ReporteBienes;